
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus, Sliders } from "lucide-react";
import { useEffect, useRef } from "react";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

interface ProductSearchInputProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onCreateNew?: () => void;
  showCreateButton?: boolean;
  placeholder?: string;
  onToggleFilters?: () => void;
  filtersVisible?: boolean;
  filtersDisabled?: boolean;
  style?: React.CSSProperties;
}

const ProductSearchInput = ({ 
  searchTerm, 
  setSearchTerm,
  onCreateNew,
  showCreateButton = false,
  placeholder = "Cerca un prodotto...",
  onToggleFilters,
  filtersVisible = false,
  filtersDisabled = false,
  style
}: ProductSearchInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // Rimetti il focus se cambia il valore ma il campo è ancora presente
    inputRef.current?.focus();
  }, [searchTerm]);
  const { theme } = useThemeConfig();

  return (
    <div>
      <div className="flex gap-2 items-center">
        <div className="relative mt-1 flex-1">
          <Input
            id="search"
            ref={inputRef}
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pr-8"
            style={{
              backgroundColor: theme.backgroundColor,
              color: theme.primaryColor || theme.textColor,
            } as React.CSSProperties}
            readOnly
            onFocus={(e) => {
              // Posticipa la rimozione di readOnly
              setTimeout(() => {
                e.target.removeAttribute("readonly");
              }, 100);
            }}
          />
          {onToggleFilters && (
            <button
              type="button"
              onClick={onToggleFilters}
              disabled={filtersDisabled}
              aria-label={filtersVisible ? 'Nascondi filtri' : 'Mostra filtri'}
              className="absolute right-2 top-1/2 -translate-y-1/2"
              style={{
                color: filtersVisible ? theme.primaryColor : theme.textColor,
                opacity: filtersDisabled ? 0.5 : 1
              }}
            >
              <Sliders className="h-4 w-4" />
            </button>
          )}
        </div>
        {showCreateButton && onCreateNew && (
          <Button
            type="button"
            size="sm"
            onClick={onCreateNew}
            className="mt-1"
          >
            <Plus className="h-4 w-4 mr-1" />
            Nuovo
          </Button>
        )}
      </div>
    </div>
  );
};

export default ProductSearchInput;
